import api from "@/lib/api";

export const fileUrl = (id) => (id ? `${process.env.REACT_APP_BACKEND_URL}/api/public/files/${id}` : null);

export async function uploadSiteImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/site/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.id;
}

export const RES_STATUS = {
  pendente: { label: "Pendente", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  confirmada: { label: "Confirmada", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  recusada: { label: "Recusada", cls: "bg-red-100 text-red-800 border-red-200" },
};

export const SITE_EDITORS = ["owner", "admin"];
export const RESERVATION_ROLES = ["owner", "admin", "salesperson"];
